import { render, staticRenderFns } from "./TrainingGraphs.vue?vue&type=template&id=721896d1&"
import script from "./TrainingGraphs.vue?vue&type=script&lang=js&"
export * from "./TrainingGraphs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports